module.exports = __webpack_public_path__ + "img/scorecard-big.ebfc2e36.jpg";